export const CATALOG_URL =
  "https://schemastore.azurewebsites.net/api/json/catalog.json";
export const SCHEMA_URL = "https://schemastore.azurewebsites.net/schemas/json/";
